import React from 'react';
import useScrollAnimation from '../hooks/useScrollAnimation';

// Start at 0.15 opacity so staggered items are never invisible (no "broken" appearance)
const presets = {
  fadeUp: {
    hidden: { opacity: 0.15, transform: 'translateY(20px)' },
    visible: { opacity: 1, transform: 'translateY(0)' },
  },
  fadeIn: {
    hidden: { opacity: 0.15 },
    visible: { opacity: 1 },
  },
  fadeLeft: {
    hidden: { opacity: 0.15, transform: 'translateX(-20px)' },
    visible: { opacity: 1, transform: 'translateX(0)' },
  },
  fadeRight: {
    hidden: { opacity: 0.15, transform: 'translateX(20px)' },
    visible: { opacity: 1, transform: 'translateX(0)' },
  },
  scaleUp: {
    hidden: { opacity: 0.15, transform: 'scale(0.97)' },
    visible: { opacity: 1, transform: 'scale(1)' },
  },
};

export default function AnimateOnScroll({
  children,
  animation = 'fadeUp',
  delay = 0,
  duration = 450,
  className = '',
}) {
  const [ref, isVisible] = useScrollAnimation();
  const preset = presets[animation] || presets.fadeUp;

  const style = {
    ...(isVisible ? preset.visible : preset.hidden),
    transition: `all ${duration}ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${delay}ms`,
  };

  return (
    <div ref={ref} style={style} className={className}>
      {children}
    </div>
  );
}
